import React, { useEffect, useLayoutEffect, useState, useRef } from 'react'
import { IColumnTypes } from 'components/spreadsheet/types'
import { getRowHeightVariable } from 'components/spreadsheet/helpers/functions'
import { ViewTypes } from 'components/spreadsheet/constants/const'
import { Link } from 'components/icons'
import { cellStyles } from 'components/spreadsheet/components/cell/styles'

interface LinkCellProps {
  value: string | null
  align: 'center' | 'left' | 'right'
  color: string
  kind: IColumnTypes
  readOnly: boolean
  editing: boolean
  rowHeight: number
  selected: boolean
  validation: boolean
  handleKeyDown: (event: React.KeyboardEvent) => void
  setCellValue: (value: string | null) => void
  isExpanded?: boolean
  type: ViewTypes
  displayLink: boolean
}

const styles = cellStyles()

const LinkCellComponent: React.FC<LinkCellProps> = ({
  value,
  align,
  color,
  kind,
  readOnly,
  editing,
  rowHeight,
  selected,
  validation,
  setCellValue,
  handleKeyDown,
  isExpanded,
  type,
  displayLink
}) => {
  const linkRef = useRef<HTMLInputElement>(null)
  const [currentValue, setCurrentValue] = useState<string>(value ? value : '')

  useEffect(() => {
    const newValue = value ? value : ''
    if (newValue !== currentValue) {
      setCurrentValue(newValue)
    }
  }, [value])

  useLayoutEffect(() => {
    if (linkRef.current && editing) {
      linkRef.current.focus()
    }
  }, [editing])

  const isForm = type === ViewTypes.FORM
  if (kind === 'link' && editing && !readOnly) {
    return (
      <input
        className={styles.editing({ focused: true, class: 'cell-value-editing' })}
        data-focussed
        value={currentValue ? currentValue : ''}
        style={{ height: `${getRowHeightVariable(rowHeight) - 2}px` }}
        onChange={(event) => {
          setCurrentValue(event.target.value)
          setCellValue(event.target.value)
        }}
        onKeyDown={handleKeyDown}
        ref={linkRef}
      ></input>
    )
  } else {
    return (
      <div
        className={styles.value({ focused: selected, class: 'cell-value' })}
        data-focussed={selected || undefined}
        tabIndex={-1}
        style={{
          textAlign: align,
          color: color,
          width: 'var(--cell-width)',
          maxWidth: 'var(--cell-width)'
        }}
      >
        {value !== '' && (
          <div
            style={{
              maxWidth: isExpanded ? (isForm ? 1000 : 500) : 'calc(var(--cell-width) - 20px)'
            }}
            className={styles.content({
              validation,
              class: `truncate flex items-center ${!displayLink && 'justify-center'}`
            })}
          >
            <a href={value ? value : '#'} target="_blank" rel="noopener noreferrer" className="truncate ml-[5px]">
              {value ? displayLink ? value.toString() : <Link /> : ''}
            </a>
          </div>
        )}
      </div>
    )
  }
}

export const LinkCell = LinkCellComponent
